





import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';

@Component({
  
})
export default class ActionsHistoryButton extends BaseComponent {
}
